import React, { ReactElement, useRef, useState, useEffect } from 'react';
import styles from './messageOptions.module.scss';
import { ResponseType } from '@/modules/chat/types/message';

type Props = {
  options: string[];
  onOptionClick: (option: string, metadata: ResponseType) => void;
};

const MessageOptions = (props: Props): ReactElement => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (scrollContainerRef.current?.offsetLeft || 0));
    setScrollLeft(scrollContainerRef.current?.scrollLeft || 0);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - (scrollContainerRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 2; // Scroll speed multiplier
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  if (props.options.length === 0) {
    return <></>;
  }

  return (
    <div className={styles['message-options-wrapper']}>
      <div
        className={styles['message-options']}
        ref={scrollContainerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        {props.options.map((value, index) => (
          <button
            key={index}
            className={styles['message-option']}
            onClick={() => props.onOptionClick(value, 'option')}
          >
            <p className={styles['option-text']}>{value}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MessageOptions;
